module.exports = __webpack_public_path__ + "img/spotify.c406c846.svg";